module.exports = "/_next/static/images/fd908578f3cf870b85a7dde32524ce73-blue-frozen-icon.svg.webp";